import { render } from "./index-service.vue?vue&type=template&id=537249b8&scoped=true"
import script from "./index-service.vue?vue&type=script&lang=js"
export * from "./index-service.vue?vue&type=script&lang=js"

import "./index-service.vue?vue&type=style&index=0&id=537249b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537249b8"]])

export default __exports__